'use client';

import { JSX, useState } from 'react';
import { getSearchUrl, SearchFilterContentTypes, SearchOrigins } from 'search-gateway-client';

import { NavSearchProps } from '../context/NavSearchContext';
import NavSearch from '../elements/NavSearch';
import { SearchBarVariant } from '../elements/NavSearchElements/searchUtils';

type SearchBarProps = {
    imagesUrl: string;
    searchOrigin?: SearchOrigins;
    useSnapshotsUI?: boolean;
};

export default function SearchBar({ imagesUrl, searchOrigin, useSnapshotsUI }: SearchBarProps): JSX.Element {
    const [showSuggestions, setShowSuggestions] = useState(false);
    const handleSubmit: NavSearchProps['onSubmit'] = (contentType, searchTerm, searchOriginOverride) => {
        const searchUrl = getSearchUrl({
            contentType: contentType,
            searchTerm: searchTerm,
            searchOrigin: searchOriginOverride || searchOrigin,
        });
        window.location.href = searchUrl;
    };

    return (
        <NavSearch
            contentType={SearchFilterContentTypes.All_videos_content_type}
            onSubmit={handleSubmit}
            userHasAnySubscription
            isEnterpriseMember
            pproPluginEnabled
            isSearchAppLoaded={() => false}
            imagesUrl={imagesUrl}
            searchOrigin={searchOrigin}
            showSuggestions={showSuggestions}
            setShowSuggestions={setShowSuggestions}
            useSnapshots={useSnapshotsUI || false}
            searchBarVariant={SearchBarVariant.TopNav}
        />
    );
}
